import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Modal, Nav, Row, Tab } from "react-bootstrap";
import {
  BsGridFill,
  BsHeartFill,
  BsFillGearFill,
  BsMegaphoneFill,
} from "react-icons/bs";
import { FaPowerOff } from "react-icons/fa6";
import MainContent from "./MainContent";
import Wishlist from "./Wishlist";
import Account from "./Account";
import Campagin from "./Campagin";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Auth } from "../../Contexts/AuthContext";
import CustomLoader from "../../Components/comman/Loader/CustomLoader";

const Sidebar = () => {
  const [isLoading, setIsLoading] = useState(false);
  // const { tabName } = useParams();
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => {
    setShow(false);
    isLoading(true);
    navigate("/influencer/dashboard");
  };
  const { logOut } = useContext(Auth);
  const handleLogout = () => {
    logOut();
    <CustomLoader visible={isLoading} />;
    setShow(false);
  };
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="main-sidebar-wrapper">
        <Nav variant="pills" className="flex-column">
          <Nav.Item className="sidebar-list-item">
            <Nav.Link as={Link} to="/influencer/dashboard" eventKey="dashboard">
              <BsGridFill className="icon" /> Dashboard
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="sidebar-list-item">
            <Nav.Link as={Link} to="/influencer/campaigns" eventKey="campaigns">
              <BsMegaphoneFill className="icon" /> Campaigns
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="sidebar-list-item">
            <Nav.Link as={Link} to="/influencer/wishlist" eventKey="wishlist">
              <BsHeartFill className="icon" /> Wishlist
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="sidebar-list-item">
            <Nav.Link as={Link} to="/influencer/account" eventKey="account">
              <BsFillGearFill className="icon" /> Account
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="sidebar-list-item">
            <Nav.Link eventKey="sign-out" onClick={handleShow}>
              <FaPowerOff className="icon" /> SignOut
            </Nav.Link>
          </Nav.Item>
        </Nav>

        {/* <Col sm={10} className="sidebar-content-wrapper">
              <Tab.Content>
                <Tab.Pane eventKey="dashboard">
                  <MainContent />
                </Tab.Pane>
                <Tab.Pane eventKey="campaigns">
                  <Campagin />
                </Tab.Pane>
                <Tab.Pane eventKey="wishlist">
                  <Wishlist />
                </Tab.Pane>
                <Tab.Pane eventKey="settings">
                  <Account />
                </Tab.Pane>
                <Tab.Pane eventKey="sign-out"></Tab.Pane>
              </Tab.Content>
            </Col> */}

        <Modal
          show={show}
          onHide={handleClose}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="sign-out-modal"
        >
          <Modal.Body>
            <p className="sign-out-text">Are You Sure You Want To Sign Out ?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClose} className="no-btn">
              No
            </Button>
            <Button className="yes-btn" onClick={handleLogout}>
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      {/* <div className="brand-sidebar-main">
        <Nav variant="pills" className="flex-column">
          <Nav.Item className="sidebar-list-item">
            <Nav.Link eventKey="dashboard" as={Link} to="/brand/dashboard">
              <BsFillHouseDoorFill className="icon" /> Home
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="sidebar-list-item">
            <Nav.Link as={Link} to="/brand/campaigns" eventKey="campaigns">
              <BsMegaphoneFill className="icon" /> Campaigns
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="sidebar-list-item">
            <Nav.Link as={Link} to="/brand/analytics" eventKey="analytics">
              <BsFillLightbulbFill className="icon" /> Analytics
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="sidebar-list-item">
            <Nav.Link as={Link} to="/brand/inbox" eventKey="inbox">
              <BsInboxFill className="icon" /> Inbox
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="sidebar-list-item">
            <Nav.Link as={Link} to="/brand/account" eventKey="account">
              <BsFillGearFill className="icon" /> Account
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div> */}
    </>
  );
};

export default Sidebar;
